import React from 'react';

import { Box } from '@hivebrite/design-system/Box';
import { Container } from '@hivebrite/design-system/Container';
import { useMatchBreakpoint } from '@hivebrite/design-system/Theme';

import Grid, { Col, Row } from 'hb-react/shared/components/DesignSystem/Grid';

interface DetailsLayoutProps {
  children: React.ReactElement;
}

const DetailsLayout = ({ children }: DetailsLayoutProps) => {
  const isMobile: boolean = useMatchBreakpoint(['s']);

  return (
    <Container height="auto" data-testid="forum-details">
      <Grid width="100%" height="100%" mx={isMobile ? 0 : undefined}>
        <Row>
          <Col
            offset={{
              m: 0,
              l: 1 / 12,
              xl: 2 / 12,
            }}
            width={{
              m: 1,
              l: 10 / 12,
              xl: 8 / 12,
            }}
          >
            <Box display="block" mt={{ _: 0, m: 6 }} mb={{ _: 0, m: 18 }}>
              {children}
            </Box>
          </Col>
        </Row>
      </Grid>
    </Container>
  );
};

export default DetailsLayout;
